import { makeVar } from '@apollo/client';

const isLoggedInVar = makeVar(null);

export default isLoggedInVar;
